import { execAdmin } from '@src/apis/reware/utils';

import type {
  PricingRulePositionResult,
  UpdatePricingRulePositionExecVariables,
  UpdatePricingRulePositionExecResponse,
} from './types';

export interface UpdatePricingRulePositionArgs {
  partnerId: number;
  ruleId: number;
  newPosition: number;
}

export const updatePricingRulePosition = async ({
  partnerId,
  ruleId,
  newPosition,
}: UpdatePricingRulePositionArgs): Promise<PricingRulePositionResult> => {
  const query = `
    mutation updatePricingRulePosition(
      $partnerId: Int!
      $ruleId: Int!
      $newPosition: Int!
    ) {
      partner(id: $partnerId) {
        updatePricingRulePosition(
          ruleId: $ruleId
          newPosition: $newPosition
        ) {
          id
          position
        }
      }
    }
  `;

  const data = await execAdmin<
    UpdatePricingRulePositionExecVariables,
    UpdatePricingRulePositionExecResponse
  >(query, { variables: { partnerId, ruleId, newPosition } });

  return data.partner.updatePricingRulePosition;
};
